<section class="payment-wrapper">
    <div id="dropin-container"></div>
</section>

